import React from 'react';
import { formatCurrency } from 'utils';
import { grey } from '@mui/material/colors';
import { Circle } from '@mui/icons-material';
import { Box, Stack, Typography } from '@mui/material';
import { BoardColumnEntity } from 'components/shared/Board/types';

import { DealPipelineListItem } from '../types';

interface Props {
  column: BoardColumnEntity<DealPipelineListItem>;
}

export const ColumnHeader = ({ column }: Props) => {
  const totalDealsAmount = column.cards.reduce<number>((acc, { deal }) => (acc += deal.invoiceTotal), 0);

  return (
    <Stack gap="0.5rem">
      <Stack direction="row" gap="0.5rem" alignItems="center">
        <Typography sx={{ color: column.metaData?.nameColor }} fontWeight={500}>
          {column.title}
        </Typography>

        <Box
          sx={{
            display: 'flex',
            padding: '0 0.5rem',
            alignItems: 'center',
            borderRadius: '0.5rem',
            justifyContent: 'center',
            backgroundColor: grey[100],
          }}
        >
          <Typography>{column.cards.length}</Typography>
        </Box>
      </Stack>

      <Stack direction="row" alignItems="center" gap="0.5rem">
        <Typography color="textSecondary">Total: {formatCurrency(totalDealsAmount, true)}</Typography>

        <Circle sx={{ fontSize: 6 }} />

        <Typography color="textSecondary">Projected: {formatCurrency(0, true)}</Typography>
      </Stack>
    </Stack>
  );
};
